import * as service from './service'
import { IDistance, EGoogdsSelected } from './consts'
const getNewSelected = (newVals, options) => {
  const newSelected: IDistance[] = []
  options.map((item, index) => {
    const currItem = item.find(curritem => curritem.value === newVals[index])
    newSelected.push({
      value: newVals[index],
      label: currItem ? currItem.label : ''
    })
  })
  return newSelected
}
export default {
  namespace: 'widgetAcceptOrderSettings',
  state: {
    tipsData: {
      tips: '',
      usingAliveTime: ''
    },
    initData: {
      goodsType: []
    },
    defaultSubmitData: {
      sendDistance: {},
      pickupDistance: {}
    },
    takeDistance: [],
    takeDistanceOptions: [],
    sendDistance: [],
    sendDistanceOptions: []
  },
  effects: {
    * conf ({ payload }, { call, put }) {
      const res = yield call(service.conf, payload)
      const bizData = res.data.data

      // 构造已选物品类型 goodsTypeSelected
      // const goodsTypeSelected = bizData.goodsType.filter(
      //   item => item.selected === EGoogdsSelected.selected
      // )

      // 构造defaultSubmitData
      const defaultSubmitData = {
        sendDistance: {
          min: bizData.sendDistance.courierMinSelected,
          max: bizData.sendDistance.courierMaxSelected
        },
        pickupDistance: {
          max: bizData.pickupDistance.courierMaxSelected
        }
        // goodsType: goodsTypeSelected.map(item => (item = item.name)).join(',')
      }
      // 构造取件距离选项 takeDistanceOptions
      const takeDistanceOptions: IDistance[] = []
      bizData.pickupDistance.conf.max.map(item =>
        takeDistanceOptions.push({
          label: `0-${item.label}`,
          value: item.value
        })
      )
      // 构造取件距离
      const takeDistance = takeDistanceOptions.find(
        item => item.value === defaultSubmitData.pickupDistance.max
      ) || { label: '', value: 0 }

      // 构造送件距离选项 sendDistanceOptions
      const sendDistanceOptions = [
        bizData.sendDistance.conf.min,
        bizData.sendDistance.conf.max
      ]
      // 构造送件距离
      const sendDistance = getNewSelected(
        [
          bizData.sendDistance.courierMinSelected,
          bizData.sendDistance.courierMaxSelected
        ],
        sendDistanceOptions
      )

      yield put({
        type: 'save',
        payload: {
          initData: bizData,
          takeDistance,
          sendDistance,
          takeDistanceOptions,
          sendDistanceOptions,
          defaultSubmitData
        }
      })
    },
    * set ({ payload, bizCodeHandler, bizCodes }, { call, put }) {
      return yield call(service.set, payload, bizCodeHandler, bizCodes)
    },
    * usePropSettingTips ({ payload }, { call, put }) {
      const res = yield call(service.usePropSettingTips, payload)
      yield put({
        type: 'save',
        payload: {
          tipsData: res.data.data
        }
      })
      return res.data.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
